import authEventEmitter from 'utils/eventEmitter';


class AuthService {

  isAuthenticated() {
    const token = localStorage.getItem('authToken');
    return !!token;
  }

  getToken() {
    return localStorage.getItem('authToken');
  }

  saveToken(token) {
    localStorage.setItem('authToken', token);
    authEventEmitter.emit('login');

  }
  storeClaims(claims) {

    if (claims?.items) {
      localStorage.setItem('userClaims', JSON.stringify(claims.items));
    }
  }

  getClaims() {
    const raw = localStorage.getItem('userClaims');
    return raw ? JSON.parse(raw) : [];
  }

  hasPermission(code) {
    const claims = this.getClaims();

    if (!Array.isArray(claims)) {
      return false;
    }
//console.log(claims);
    return claims.some(claim => claim.code === code);
  }




  logout() {
    localStorage.removeItem('authToken');
    authEventEmitter.emit('logout');
    localStorage.removeItem('roleId');
    localStorage.removeItem('username');

  }

  getUser() {
    return JSON.parse(localStorage.getItem('user')) || null;
  }

  saveUser(user) {
    localStorage.setItem('user', JSON.stringify(user));
  }

  setUsername(username) {
    localStorage.setItem('username', username);
  }
  getUsername() {
    return localStorage.getItem('username');
  }
  setCurrentRoleId(roleId) {
    localStorage.setItem('roleId', roleId);
  }
  getCurrentRoleId() {
    return localStorage.getItem('roleId');
  }

  isAdmin() {
    return localStorage.getItem('roleId') === '1';
  }
  isEmployee() {
    return localStorage.getItem('roleId') === '2';
  }
  isManager() {
    return localStorage.getItem('roleId') === '3';
  }
  getLanguage() {
    return localStorage.getItem('language');
    //i18n.changeLanguage(lang); 

  }

  getLanguageCode() {
    const lang = localStorage.getItem('language');
    if (!lang) return 'bs'; // Default to Bosnian if no language is set
    return lang === '1' ? 'bs' : lang === '2' ? 'cr' : 'sr';
    //i18n.changeLanguage(lang); 
  }

  setLanguage(language) {
    localStorage.setItem('language', language);
    //i18n.changeLanguage(lang); 

  }
}

export default new AuthService();